<div class="res-by-user-container">
  <div class="w-100 res_list_spinner_wrapper" *ngIf="spinner && this.paginationHelperModel.pageNumber === 1">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <ng-container *ngIf="reservationList.length > 0">
    <div class="res-content" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000"
         (scrolled)="loadMoreReservations()" [scrollWindow]="false">
      <div *ngFor="let reservation of reservationList">
        <div class="d-flex flex-row reservation-container mb-4" style="height: unset;">
          <div class="d-flex user-container flex-row" title="{{reservation.firstName}} {{reservation.lastName}}">
            <span class="ellipsis">{{reservation.firstName}} {{reservation.lastName}}</span>
          </div>
          <div>
            <span>{{'RESERVATION.DATE' | translate}}: </span>
            <span>{{reservation.reservationDateAndTime | date: 'dd.MM.yyyy'}}</span>
          </div>
          <div>
            <span>{{'RESERVATION.TIME' | translate}}: </span>
            <span>{{reservation.reservationDateAndTime | date: 'hh:mm a'}}</span>
          </div>
          <div class="text-left w-20">
            <span>{{'RESERVATION.NUMBER_OF_GUESTS' | translate}}: </span>
            <span>{{reservation.numberOfGuests}}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="(!reservationList || reservationList.length === 0) && !spinner;">
    <div class="d-flex w-100 flex-column justify-content-center no-reservations-container">
      <i class="pi pi-calendar-minus no-reservations-icon"></i>
      <span class="no-reservations-text">{{'RESERVATION.NO_RESERVATIONS' | translate}}</span>
    </div>
  </ng-container>
</div>
